// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__EB","cls2":"AccountMenu-cls2_QYz AccountMenu-cls1__EB"};